import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';

import { ButtonSize, TextButton } from '@prisjakt/ui/button/variants';

type Props = {
  onClick: () => void;
  className?: string;
};

export const ClearButton = ({ onClick, className }: Props) => {
  const { t } = useContext(AppContext);

  return (
    <TextButton
      className={className}
      onClick={onClick}
      size={ButtonSize.SMALL}
      containerProps={{ 'data-test': 'FeaturedFilterClear' }}
    >
      {t('filter', 'button.clear-filter')}
    </TextButton>
  );
};
